import React, { useEffect, useState,useMemo } from 'react';
import user from "../../../../assets/icons/user.svg";
import edit from "../../../../assets/icons/edit.svg";
import deleteIcon from "../../../../assets/icons/delete.svg";
import { useNavigate } from 'react-router-dom';

export default function TravellerCard({ hotelId, bookingId, bookedRoomId, guests,rno,bookedRooms,submitGuests,userId,checkInDate,checkOutDate,count,tags,timeArrival }) {
  const navigate = useNavigate();
  const [guestDetails, setGuestDetails] = useState([]);

  let status = "Trial"

  // Navigate to add or edit the guest data
  const navigateToEdit = (update, index,name,verification_id,contact,remarks,email,address,user,is_minor) => {

    if (update === "updateBooking" && index !== null && index !== undefined) {
      navigate("/requestUpdateCheckIn", {
        // This is for update data
        state: {
          bookingId: bookingId,
          bookedRoomId: bookedRoomId,
          hotelId: hotelId,
          update: update,
          index: index,
          name : name,
          verification_id : verification_id,
          contact : user?.contact || contact,
          is_minor : is_minor,
          bookedRooms : bookedRooms,
          rno : rno,
          guests : guests,
          submitGuests : submitGuests,
          userId : userId,
          remarks : remarks,
          checkInDate :checkInDate,
          checkOutDate :checkOutDate,
          address : address,
          email : email,
          tags : tags,
          timeArrival : timeArrival,
        },
      });
    }
    // This is for adding data  
    else {
      navigate("/requestUpdateCheckIn", {
        state: {
          bookingId: bookingId,
          bookedRoomId: bookedRoomId,
          hotelId: hotelId,
          rno : rno,
          guests : guests,
          bookedRooms : bookedRooms,
          submitGuests : submitGuests,
          userId : userId,
          checkInDate :checkInDate,
          checkOutDate :checkOutDate,
          tags : tags,
          timeArrival : timeArrival,
        },
      });
    }
  };

  useEffect(() => {
    const setGuests = () => {
      if (!guests[rno] || guests[rno].length === 0) {
        setGuestDetails([]); // No guests available
      } else {
        setGuestDetails(guests[rno]);
      }
    };
    setGuests();
  }, []);

  const handleDeleteUser = (index, rno) => {
  
    // Check if guests exist for the given rno
    if ( guests[rno] &&  guests[rno].length > 0) {
      // Remove the guest at the specified index
       guests[rno].splice(index, 1); // Use '1' to remove a single item
  
      // Update guest details
      setGuestDetails([...guests[rno]]);
    } else {
      // If no guests available, set an empty array
      setGuestDetails([]);
    }

  };

  const truncateName = (name) => {
    return name.length > 16 ? name.slice(0, 16) + '...' : name;
  };

  // Validate the Data
  const isGuestComplete = (guest) => {
    try{
      const guestData = {
        name: guest.name?.trim() || guest.user?.name,
        contact: guest.contact || guest.user?.contact,
        email: guest.email?.trim() || guest.user?.email,
        address: guest.address?.trim() || guest.user?.address,
        verification_id: guest.verification_id || guest.user?.verification_id,
      };
  
      const verificationIds = (guestData.verification_id || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
  
      return (
        !!guestData.name?.trim() &&
        !!guestData.contact &&
        !!guestData.email?.trim() &&
        !!guestData.address?.trim() &&
        verificationIds.length === 2
      );
    }catch(error){
      console.log(error);
    }
  };
  
  // Display loading, error, or guest details
  return (
    <>
      <div className="traveller-room-status">
        <h6></h6>
      </div>

      <div className='traveller-card'>
  
        {/* Room Id */}
        <div className='traveller-roomId'>
          <h4>Room ID: {count}</h4>
        </div>

        {/* Display guest details or show a message if no guests */}
        {guestDetails.length === 0 ? (
          <div className='no-guests' style={{ textAlign: 'center', paddingTop: '4px', paddingBottom: '4px' }}>
            No guest details available
          </div>
        ) : (
          guestDetails.map((guest, index) => (
            <div className='traveller-name' key={index}
              style={{
              backgroundColor: guest.hotel_approved === "HOTEL_APPROVED" ? "#FFF2F2" : "transparent"
              }}
            >
              {/* Guest Name */}
              <div className='name'>
                <h4>{truncateName(guest.name) || "Guest Name"}</h4>
              </div>

              {/* Edit Guest Details */}
              <div className='name-edit'>
                <div className={(guest.is_minor || isGuestComplete(guest)) ? "traveller-id-uploaded" : "traveller-id"}>
                 <h5>
                    {guest.is_minor
                      ? "Child · under 18"
                      : isGuestComplete(guest)
                      ? "Details Complete"
                      : "Details Missing"}
                  </h5>
                </div>

              {!bookedRooms.webCheckIn_time_status &&
                (!guest.hotel_approved ||
                  guest.hotel_approved === "HOTEL_DENIED" ||
                  guest.hotel_approved === "HOTEL_UNSPECIFIED") &&
                  status !== "Declined_Hotel" &&
                  status !== "Completed_Hotel" && (
                  <>
                    <div className="edit-icon">
                      <img
                        src={edit}
                        alt="edit icon"
                        onClick={() =>
                          navigateToEdit(
                            "updateBooking",
                            index,
                            guest.name,
                            guest.verification_id,
                            guest.contact,
                            guest.remarks,
                            guest.email,
                            guest.address,
                            guest?.user,
                            guest.is_minor,
                          )
                        }
                      />
                    </div>

                    <div className="edit-icon">
                      <img
                        src={deleteIcon}
                        alt="delete icon"
                        onClick={() => handleDeleteUser(index, rno)}
                      />
                    </div>
                  </>
              )}

              </div>

            </div>
          ))
        )}

        {/* Button to Add Guest */}
        <div className='traveller-btn'>
        {!bookedRooms.webCheckIn_time_status && (!(status === "Declined_Hotel" || status === "Completed_Hotel")) && (

          <button onClick={() => navigateToEdit()}>
            Add guest to the room
            <img src={user} alt='user icon' />
          </button>
        )}
        </div>
      </div>
    </>
  );
}
